import { lazy } from 'react';
import { Loadable } from '../../loadable/components/Loadable';

export const AsyncCollectionsPage = Loadable({
  Component: lazy(() =>
    import('./CollectionsPage').then((mod) => ({
      default: mod.CollectionsPage,
    }))
  ),
});
